import {Extensions} from '@tiptap/core';
import {IElement} from '../../../../incase-domain/elements';
import {ELEMENT} from '../../../../incase-domain/elements/base/ElementTypes';
import {tableExtensions} from './tableExtensions';
import {textExtensions} from './textExtensions';

export function getElementExtensions(element: IElement): Extensions {
    switch (element.type) {
        case ELEMENT.STATIC_TEXT:
            return textExtensions;
        case ELEMENT.STATIC_TABLE_V2:
            return [...textExtensions, ...tableExtensions];
        default:
            return textExtensions;
    }
}
